import { _ as _objectSpread2, b as _slicedToArray } from './transitions-0e124def.esm.js';
import { space as space$1 } from '@hover/blueprint-theme';
import { fromEntries, entries } from '@hover/utilities';

var noZero = function noZero(tuple
// eslint-disable-next-line eqeqeq
) {
  return tuple[0] != 0;
};
var space = /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, space$1), /*#__PURE__*/fromEntries( /*#__PURE__*/entries(space$1).filter(noZero).map(function (_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
    key = _ref2[0],
    value = _ref2[1];
  return ["-".concat(key), "-".concat(value)];
})));

export { space as s };
